import { Spinner } from './spinner';

interface Props {
    /**
     * Optional caption rendered under the spinner, e.g. "Searching for HotSpot...".
     * Omit it to get the plain spinner the app shows for full-screen loads.
     */
    text?: string;
}

// The theme centres this box with `#Panel_loadingScreenLabel { top: 50%; left: 50%;
// margin-left: -42px; margin-top: -42px }`, and those half-offsets are hardcoded for the
// 84px spinner-only box (34px spinner + 25px of `.ab-content` padding either side). A caption
// makes the box bigger, so the fixed offsets push it down and to the right. `alert-wait-captioned`
// carries the size-independent centring, and its rule sits with the rest of the alert styling in
// the theme CSS:
//
//     #Panel_loadingScreenLabel.alert-wait-captioned {
//         top: 50%;
//         left: 50%;
//         margin: 0;
//         transform: translate(-50%, -50%);
//     }
//
// It has to be written against the id: the rule it overrides is an id (specificity 1-0-0) and a
// bare class (0-1-0) would lose to it whatever the source order, so pairing the two gives 1-1-0.
const ScreenLoadingIndicator = ({ text }: Props) => (
    <div id="Panel_loadingScreenLabel" data-testid="loadingScreen" className={text ? 'alert alert-wait alert-wait-captioned' : 'alert alert-wait'}>
        <div className="alert-body">
            <div className="ab-content overthrow">
                <Spinner type="large" />
                {text ? <p>{text}</p> : null}
            </div>
        </div>
    </div>
);

export { ScreenLoadingIndicator };
